<template>
  <v-app id="footer-ticket">
    <v-container class="mt-0">
      <v-col class="d-block" style="text-align: center" cols="12">
        <h4>Nuestros</h4>
        <h1>Aliados</h1>
      </v-col>
      <v-row class="aliados slider">
        <v-col class="d-flex flex-md-row slide div-slide-alidos" title="" v-for="aliado in aliados">
          <v-img :src="aliado.src" :class="cssRefresh ? 'img-slide-aliados' : ''" />
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>
<script>
import axios from "axios";
import { configApi } from "../../api/configApi";
import { headers } from "../../api/headers";
export default {
  mounted() { },
  async beforeCreate() {
    await axios
      .get(`${configApi.apiUrl}buscarimagenaliados`, null, { headers: headers })
      .then((response) => {
        this.ftaliados = response.data.data;

        this.aliados = this.ftaliados.map((item) => {
          return { src: item.url };
        });

        this.cssRefresh = true;

        $(document).ready(function () {
          $(".aliados").slick({
            slidesToShow: 6,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 3000,
            arrows: false,
            dots: false,
            vertical: false,
            pauseOnHover: false,
            responsive: [
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 4,
                },
              },
              {
                breakpoint: 520,
                settings: {
                  slidesToShow: 3,
                },
              },
            ],
            variableWidth: true,
          });
        });
      });
  },
  data() {
    return {
      aliados: [],
      ftaliados: [],
      cssRefresh: false,
    };
  },
};
</script>
<style>
footer {
  background-color: #000000;
  margin-top: 40px;
}

.footer {
  padding: 35px 15px 0px 15px;
  color: white;
}

.list-social-links a {
  color: white;
}

.list-social-links a:hover {
  color: white;
  opacity: 0.8;
}

.title-cont-mini-footer {
  text-transform: uppercase;
  font-size: 16px;
  color: #bc244a;
}

.list-menu-links a {
  color: white;
}

.list-menu-links a:hover {
  color: white;
  opacity: 0.8;
}

.cont-mini-footer {
  margin-bottom: 15px;
}

.copyright {
  color: white;
  text-align: center;
  padding: 10px 10px;
  background-color: #1e212d;
}

div.div-slide-alidos {
  width: 145px !important;
  text-align: center !important;
}

div>img.img-slide-aliados {
  width: 120px !important;
  height: 90px !important;
}
</style>
